import type {Authentication, ServerAuthenticationSuccessHandler} from './types.ts';

export const delegatingSuccessHandler = (handlers: Array<ServerAuthenticationSuccessHandler>) => {

    return async ({exchange, chain}, authentication: Authentication) => {
        for (const handler of handlers) {
            await handler({exchange, chain}, authentication);
        }
    };
}
